import { render, staticRenderFns } from "./PageDocMenusAide.vue?vue&type=template&id=ee9132ae&"
import script from "./PageDocMenusAide.vue?vue&type=script&lang=js&"
export * from "./PageDocMenusAide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee9132ae')) {
      api.createRecord('ee9132ae', component.options)
    } else {
      api.reload('ee9132ae', component.options)
    }
    module.hot.accept("./PageDocMenusAide.vue?vue&type=template&id=ee9132ae&", function () {
      api.rerender('ee9132ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Menus/PageDocMenusAide.vue"
export default component.exports